
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4564)"}},[_c('path',{attrs:{"d":"M11.893 3.41l-1.731-.42-.384-.269.2-.286a.34.34 0 00-.084-.474l-.64-.448a.34.34 0 00-.475.084l-.2.286-.181-.127a.359.359 0 00-.5.089L6.838 3.36a.359.359 0 00.089.5l.18.126-.627.896.893 1.277.933-1.334.385.269.988 1.482a.14.14 0 00.173.05c.28-.122 1.03-.5 1.53-1.216.501-.715.599-1.55.618-1.854a.14.14 0 00-.107-.146zM4.628 7.53L3.205 9.564a.34.34 0 00.084.475l.64.448a.34.34 0 00.475-.084L5.52 8.806 4.628 7.53z"}}),_c('path',{attrs:{"d":"M8.796 9.565L4.894 3.986l.18-.126a.359.359 0 00.089-.5l-1.06-1.515a.359.359 0 00-.5-.089l-.18.127-.2-.286a.34.34 0 00-.476-.084l-.64.448a.34.34 0 00-.084.474l.2.286-.384.27-.33.08-1.4.34A.14.14 0 000 3.555c.019.304.117 1.14.617 1.854.5.716 1.252 1.094 1.53 1.217a.14.14 0 00.174-.051l.8-1.199.188-.283.385-.27 3.902 5.58a.34.34 0 00.475.083l.64-.448a.34.34 0 00.084-.474z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4564"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    